import { coinPaymentService } from "../../services/coinPayment/coinPayment";


export const coinPaymentAction = {
    getCoins: async () => {
        try {
            const response = await coinPaymentService.getCoins()
            return response
        } catch (error) {
            console.log(error);
        }
    },
    getAdminCoinId:async () => {
        try {
            const response = await coinPaymentService.getAdminCoinId()
            return response
        } catch (error) {
            console.log(error);
        }
    }
}